const fetchIPInfo = () => fetch('https://ipapi.co/json').then((resp) => resp.json());

export const getUserLocation = () => new Promise((resolve, reject) => {
  navigator.geolocation.getCurrentPosition(
    (position) => {
      fetchIPInfo()
        .then((resp) => resolve({ coords: position.coords, country: resp.country_code }))
        .catch((error) => resolve({ coords: position.coords }));
    },
    (error) => {
      fetchIPInfo()
        .then((resp) => resolve({
          coords: { latitude: resp.latitude, longitude: resp.longitude },
          country: resp.country_code,
        }))
        .catch((e) => reject(e));
    },
  );
});
